var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
function convertNodeToOption(node) {
    const _a = node, { key } = _a, _b = _a.props, { children, value } = _b, restProps = __rest(_b, ["children", "value"]);
    return Object.assign({ key, value: value !== undefined ? value : key, children }, restProps);
}
export function convertChildrenToData(nodes, optionOnly = false) {
    return toArray(nodes)
        .map((node, index) => {
        if (!React.isValidElement(node) || !node.type) {
            return null;
        }
        const _a = node, { type: { isSelectOptGroup }, key } = _a, _b = _a.props, { children } = _b, restProps = __rest(_b, ["children"]);
        if (optionOnly || !isSelectOptGroup) {
            return convertNodeToOption(node);
        }
        return Object.assign(Object.assign({ key: `${key === null ? index : key}`, label: key }, restProps), { options: convertChildrenToData(children) });
    })
        .filter(data => data);
}
